import { InformationCircleIcon } from "@heroicons/react/20/solid";
import React from "react";

const AlertBlue: React.FC<
  React.PropsWithChildren<{
    title?: React.ReactNode;
  }>
> = ({ title, children }) => {
  return (
    <div className="bg-blue-50 p-4 rounded-md">
      <div className="flex">
        <div className="flex-shrink-0">
          <InformationCircleIcon className="w-5 h-5 text-blue-400" aria-hidden="true" />
        </div>
        <div className="md:flex flex-1 md:justify-between ml-3">
          <p className="text-blue-700 text-sm">{title ?? "Add Title"}</p>
        </div>
        <div className="mt-2 text-sm">{children}</div>
      </div>
    </div>
  );
};

export default AlertBlue;
